<template>
    <v-card class="ma-3 pa-5">
        <div class="csvContainer">
            <v-btn color="primary" small @click="downloadCulturesCSV">
                Download CSV
            </v-btn>
        </div>
        <v-data-table
            :headers="headers"
            :items="tData"
            :items-per-page="20"
            :item-key="tData.id"
            :options.sync="options"
            :loading="loading"
            class="elevation-1 "
        >
            <template v-slot:item.code="{ item }">
                <v-textarea
                    rows="1"
                    flat
                    dense
                    solo
                    class="ma-0 pa-0"
                    hide-details
                    row-height="15"
                    auto-grow
                    v-model="item.code"
                ></v-textarea>
            </template>
            <template v-slot:item.locale.la_culture="{ item }">
                <v-textarea
                    rows="1"
                    flat
                    dense
                    placeholder="LA"
                    solo
                    class="ma-0 pa-0"
                    hide-details
                    row-height="15"
                    auto-grow
                    v-model="item.locale.la_culture"
                ></v-textarea>
            </template>
            <template v-slot:item.locale.et_culture="{ item }">
                <v-textarea
                    rows="1"
                    flat
                    dense
                    placeholder="ET"
                    solo
                    class="ma-0 pa-0"
                    hide-details
                    row-height="15"
                    auto-grow
                    v-model="item.locale.et_culture"
                ></v-textarea>
            </template>
            <template v-slot:item.locale.en_culture="{ item }">
                <v-textarea
                    rows="1"
                    flat
                    dense
                    placeholder="EN"
                    solo
                    class="ma-0 pa-0"
                    hide-details
                    row-height="15"
                    auto-grow
                    v-model="item.locale.en_culture"
                ></v-textarea>
            </template>
            <template v-slot:item.locale.fi_culture="{ item }">
                <v-textarea
                    rows="1"
                    flat
                    dense
                    placeholder="FI"
                    solo
                    class="ma-0 pa-0"
                    hide-details
                    row-height="15"
                    auto-grow
                    v-model="item.locale.fi_culture"
                ></v-textarea>
            </template>
            <template v-slot:item.locale.lt_culture="{ item }">
                <v-textarea
                    rows="1"
                    flat
                    dense
                    placeholder="LT"
                    solo
                    class="ma-0 pa-0"
                    hide-details
                    row-height="15"
                    auto-grow
                    v-model="item.locale.lt_culture"
                ></v-textarea>
            </template>
            <template v-slot:item.growth_phase_id="{ item }">
                <v-select
                    item-value="id"
                    item-text="name"
                    hide-details
                    dense
                    solo
                    flat
                    :items="cultureTypes"
                    label="Growth phase type"
                    v-model="item.growth_phase_id"
                >
                </v-select>
            </template>
            <template v-slot:item.culture_type="{ item }">
                <v-select
                    hide-details
                    dense
                    solo
                    flat
                    :items="availableCultureTypes"
                    label="Culture Type"
                    v-model="item.culture_type"
                >
                </v-select>
            </template>
            <template v-slot:item.level_0_growth_phase="{ item }">
                <v-text-field
                    type="number"
                    hide-details
                    dense
                    solo
                    flat
                    v-model.number="item.level_0_growth_phase"
                >
                </v-text-field>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon class="mr-2" @click="editItem(item)">
                    mdi-content-save-outline
                </v-icon>
                <v-icon class="mr-2" @click="deleteItem(item)">
                    mdi-trash-can-outline
                </v-icon>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import CultureTableService from '@/service/CultureTableService'

export default {
    name: 'CultureListTable',
    data() {
        return {
            tableDataSize: 0,
            expanded: [],
            singleExpand: false,
            tData: [],
            loading: false,
            options: {},
            headers: [
                { text: 'Index', value: 'code', align: 'start', sortable: false, width: '5%' },
                { text: 'LA', value: 'locale.la_culture', align: 'start', sortable: false, width: '13%' },
                { text: 'ET', value: 'locale.et_culture', align: 'start', sortable: false, width: '13%' },
                { text: 'EN', value: 'locale.en_culture', align: 'start', sortable: false, width: '13%' },
                { text: 'FI', value: 'locale.fi_culture', align: 'start', sortable: false, width: '13%' },
                { text: 'LT', value: 'locale.lt_culture', align: 'start', sortable: false, width: '13%' },
                { text: 'Growth Phase Type', value: 'growth_phase_id', align: 'start', sortable: false, width: '13%' },
                { text: 'Culture Type', value: 'culture_type', align: 'start', sortable: false, width: '10%' },
                { text: 'Level 0 Growth phase', value: 'level_0_growth_phase', align: 'start', sortable: false, width: '7%' },
                { text: '', value: 'actions', sortable: false, width: '5%' },
            ],
        }
    },
    watch: {
        options: {
            async handler() {
                this.loading = true
                await this.fetchCulture()
                this.loading = false
            },
            deep: true,
        },
        cultures: function() {
            this.tData = this.getCulturesOrderedByCode
        },
    },
    methods: {
        ...mapActions('culture', ['editCulture', 'fetchCulture', 'deleteCulture']),
        async editItem(item) {
            await this.editCulture(item)
        },
        async deleteItem(item) {
            if (confirm('Are you sure?')) {
                await this.deleteCulture(item.id)
            }
        },
        async downloadCulturesCSV() {
            const resp = await CultureTableService.downloadCulturesCSV()
            const url = window.URL.createObjectURL(new Blob([resp.data]))

            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'cultures_table_data.csv')
            document.body.appendChild(link)
            link.click()
        },
    },
    computed: {
        ...mapState('culture', ['cultures', 'cultureTypes', 'availableCultureTypes']),
        ...mapGetters('culture', ['getCulturesOrderedByCode']),
    },
}
</script>

<style scoped>
.csvContainer {
    display: flex;
    align-items: center;
    justify-content: end;
    padding: 15px 0;
}
</style>
